import { useEffect, useState } from 'react';
import { useValidateUserQuery } from './services/authUser';
import { useMsal } from '@azure/msal-react';

export const useGetAuthUser = () => {
  const { instance } = useMsal();
  const [username, setUsername] = useState<string>('');

  useEffect(() => {
    const account = instance.getAllAccounts();

    if (account?.[0]?.username) {
      setUsername(account?.[0]?.username);
    }
  }, [instance]);

  useEffect(() => {
    const interval = setInterval(() => {
      const storedToken = localStorage.getItem('authToken');
      if (storedToken) {
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  const {
    data: authUser,
    isLoading: isLoadingAuthUser,
    refetch,
  } = useValidateUserQuery(username ?? '', {
    skip: !username,
  });

  useEffect(() => {
    if (username) {
      refetch();
    }
  }, [username, refetch]);

  return {
    authUser: authUser?.data?.ValidateUser?.actorDetails,
    isLoading: isLoadingAuthUser,
  };
};
